import 'es6-promise/auto'
import Vue from 'vue'
import Vuex from 'vuex'
import settings from './modules/settings'
import resources from './modules/resources'
import bookingTypes from './modules/bookingTypes'
import forms from './modules/forms'
import scenarios from './modules/scenarios'
import availability from './modules/availability'
import openingHours from './modules/openingHours'
import booking from './modules/booking'
import payments from './modules/payments'
import addons from './modules/addons'
import session from './modules/session'
import customer from './modules/customer'
import order from './modules/order'
import password from './modules/password'

import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    settings,
    resources,
    bookingTypes,
    forms,
    scenarios,
    availability,
    openingHours,
    booking,
    payments,
    addons,
    session,
    customer,
    order,
    password
  },
  /*
  plugins: [
    createPersistedState({
      paths: [
        'booking.options.scenario',
        'booking.options.adults',
        'booking.options.juniors',
        'booking.options.games',
        'booking.options.scenarioFilter',
        'booking.options.promoCode',
        'booking.options.addons'
      ]
    })
  ],*/
  strict: debug
})
